import { axiosInstance } from '@/lib/axios'
import { ActiveTask } from './types'

/**
 * Every task currently running in the company — regardless of who started it.
 *
 * Replaces the old fan-out of one `/status` request per tracked task every 500 ms:
 * one request now answers for the whole company, and it is the only way a second
 * user learns that a calculation is already running.
 */
export const getActiveTasks = async (companyId: string): Promise<ActiveTask[]> => {
  const response = await axiosInstance.get<ActiveTask[]>(
    `/config-api/importTask/active?companyId=${companyId}`,
  )
  return response.data ?? []
}
